module.exports = __webpack_public_path__ + "static/media/2.638ba23f.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/shirts/2.png
// module id = 1458
// module chunks = 0